import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		eBoekhouden: null,
		init: null,
	},
	getters: {
		eBoekhouden(state) {
			return state.eBoekhouden;
		},
	},
	mutations: {
		SET_EBOEKHOUDEN(state, eBoekhouden) {
			state.eBoekhouden = eBoekhouden
		},
		CLEAR_STORE(state) {
			state.init = null;
			state.eBoekhouden = null;
		}
	},
	actions: {
		async init({commit}, state) {
			if (!this.state.init) {
				await apiClient.get('settings/accounting/eboekhouden/get').then(res => {
					commit('SET_EBOEKHOUDEN', res.data);
					this.state.init = true;
				}).catch(err => {
				})
			}
		},
		createEboekhouden({commit}, eBoekhoudenCreate) {
			return new Promise((resolve, reject) => {
				apiClient.post('settings/accounting/eboekhouden/create', eBoekhoudenCreate).then(res => {
					commit('SET_EBOEKHOUDEN', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});

		},
		updateEboekhouden({commit}, eBoekhoudenUpdate) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/accounting/eboekhouden/update', eBoekhoudenUpdate).then(res => {
					commit('SET_EBOEKHOUDEN', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
